// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "account__form--ZkIl";
var _5 = "input-3YRa8";
var _6 = "confirm__input__wrapper-1Cs2f";
var _7 = "field__user-3vvFy";
var _8 = "confirm__input-103Z1";
var _9 = "loader-2B4Bw";
var _a = "rotation-3hq_u";
var _b = "input_tooltip__wrapper-p_CeH";
var _c = "field__name-1My4w";
var _d = "resendTimer-3WbPh";
var _e = "field-34MBn";
var _f = "field__icon-22hZ9";
var _10 = "field__info-3RKDo";
var _11 = "field__buttons-mlVOj";
var _12 = "field__delete-1wHy4";
var _13 = "account__subscription__toggle-3OSfe";
var _14 = "field__button-brsZ9";
var _15 = "field__change-2u76C";
var _16 = "field__connect-35EdR";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "account__form", _5 as "input", _6 as "confirm__input__wrapper", _7 as "field__user", _8 as "confirm__input", _9 as "loader", _a as "rotation", _b as "input_tooltip__wrapper", _c as "field__name", _d as "resendTimer", _e as "field", _f as "field__icon", _10 as "field__info", _11 as "field__buttons", _12 as "field__delete", _13 as "account__subscription__toggle", _14 as "field__button", _15 as "field__change", _16 as "field__connect" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "account__form": _4, "input": _5, "confirm__input__wrapper": _6, "field__user": _7, "confirm__input": _8, "loader": _9, "rotation": _a, "input_tooltip__wrapper": _b, "field__name": _c, "resendTimer": _d, "field": _e, "field__icon": _f, "field__info": _10, "field__buttons": _11, "field__delete": _12, "account__subscription__toggle": _13, "field__button": _14, "field__change": _15, "field__connect": _16 }
